// @ts-nocheck
// tslint:disable
/**
 * PalmApp Server Web API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { WorkerState } from './worker-state';

// tslint:disable
import { APIModel, APIModelOptions, AttributeMapItem } from "../base";

export class WorkerDto extends APIModel {
    /**
    * Worker identifier
    */
    id: number;
    /**
    * Idws identifier
    */
    idws: string;
    /**
    * Idwa identifier
    */
    idwa: string;
    /**
    * First name of worker
    */
    firstName: string;
    /**
    * Last name of worker
    */
    lastName: string;
    /**
    * Worker login
    */
    username: string;
    /**
    * Worker email
    */
    email: string;
    /**
    * Worker phone
    */
    phone: string;
    /**
    * Account number
    */
    accountNumber: string;
    /**
    * Account bank code
    */
    accountBankCode: string;
    /**
    * Account IBAN
    */
    accountIban: string;
    /**
    * Worker code
    */
    code: string;
    /**
    * Worker referral code
    */
    referralCode: string;
    /**
    * Currency
    */
    currency: string;
    /**
    * Average salary per hour
    */
    hourSalaryAvg: number;
    /**
    * Wage deduction
    */
    wageDeduction: number;
    /**
    * Working time
    */
    workingTime: number;
    /**
    * Month salary
    */
    monthSalary: number;
    /**
    * Current total hours
    */
    currentTotalHours: number;
    /**
    * Current budget
    */
    currentBudget: number;
    /**
    * Maximum percentage available for withdrawal
    */
    payLimitPercentage: number;
    /**
    * Worker is active
    */
    active: boolean;
    /**
    * Worker is in execution
    */
    inExecution: boolean;
    /**
    * Worker is in insolvency
    */
    inInsolvency: boolean;
    /**
    * Current pay month
    */
    currentMonth: string;
    /**
    * Date of registration
    */
    dateRegistered: string;
    /**
    * Date of last login
    */
    dateLastLogin: string;
    /**
    * Date of last payment
    */
    dateLastPayment: string;
    /**
    * Dismiss date
    */
    dismissDate: string;
    /**
    * Date of last refresh
    */
    dateLastRefresh: string;
    /**
    * Company identifier
    */
    companyId: number;
    /**
    * Code of company
    */
    companyCode: string;
    /**
    * Name of company
    */
    companyName: string;
    demo: boolean;
    state: WorkerState;

    constructor(options?: APIModelOptions) {
        super(WorkerDto.attributeTypeMap, options);
    }

    static get attributeTypeMap(): Array<AttributeMapItem> {
        return [
            { name: "id", type: "number" },
            { name: "idws", type: "string" },
            { name: "idwa", type: "string" },
            { name: "firstName", type: "string" },
            { name: "lastName", type: "string" },
            { name: "username", type: "string" },
            { name: "email", type: "string" },
            { name: "phone", type: "string" },
            { name: "accountNumber", type: "string" },
            { name: "accountBankCode", type: "string" },
            { name: "accountIban", type: "string" },
            { name: "code", type: "string" },
            { name: "referralCode", type: "string" },
            { name: "currency", type: "string" },
            { name: "hourSalaryAvg", type: "number" },
            { name: "wageDeduction", type: "number" },
            { name: "workingTime", type: "number" },
            { name: "monthSalary", type: "number" },
            { name: "currentTotalHours", type: "number" },
            { name: "currentBudget", type: "number" },
            { name: "payLimitPercentage", type: "number" },
            { name: "active", type: "boolean" },
            { name: "inExecution", type: "boolean" },
            { name: "inInsolvency", type: "boolean" },
            { name: "currentMonth", type: "string" },
            { name: "dateRegistered", type: "string" },
            { name: "dateLastLogin", type: "string" },
            { name: "dateLastPayment", type: "string" },
            { name: "dismissDate", type: "string" },
            { name: "dateLastRefresh", type: "string" },
            { name: "companyId", type: "number" },
            { name: "companyCode", type: "string" },
            { name: "companyName", type: "string" },
            { name: "demo", type: "boolean" },
            { name: "state", type: "WorkerState" }
        ];
    }
}




